import moment from 'moment'

const filtro = (data) => {
	return moment.utc(data).local().format('DD/MM/YYYY HH:mm')
}

export default filtro
